export default __webpack_public_path__ + "static/everett-medium-webfont-32f6dfa4ca2549abe25dbaae9dd04a45.woff2";